// web/src/routes/index.js
import React from 'react';
import {
  Routes as RouterRoutes,
  Route,
  Navigate,
} from 'react-router-dom';

import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import {
  protectedRoutes,
  publicRoutes,
} from 'configs/RoutesConfig';

import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

import RequirePerm from 'components/route-guard/RequirePerm';

const CHAT_WIDGET_PATH = '/chat-widget';

const Routes = () => {
  const chatWidgetRoute = publicRoutes.find(
    (route) => route.path === CHAT_WIDGET_PATH
  );

  const otherPublicRoutes = publicRoutes.filter(
    (route) => route.path !== CHAT_WIDGET_PATH
  );

  return (
    <RouterRoutes>
      {/* rota raiz */}
      <Route
        path="/"
        element={
          <Navigate
            replace
            to="/auth/login?redirect=/"
          />
        }
      />

      {/* rota pública isolada do widget */}
      {chatWidgetRoute ? (
        <Route
          path={chatWidgetRoute.path}
          element={<chatWidgetRoute.component />}
        />
      ) : null}

      {/* rotas públicas */}
      <Route element={<PublicRoute />}>
        {otherPublicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>

      {/* rotas privadas */}
      <Route element={<ProtectedRoute />}>
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <RequirePerm perm={route.meta?.perm}>
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              </RequirePerm>
            }
          />
        ))}

        <Route
          path="*"
          element={<Navigate to={AUTHENTICATED_ENTRY} replace />}
        />
      </Route>

      {/* fallback final */}
      <Route
        path="*"
        element={
          <Navigate
            replace
            to="/auth/login?redirect=/"
          />
        }
      />
    </RouterRoutes>
  );
};

export default Routes;